import React from 'react';
import { Modal, Pulse } from 'wf-react-component-library';

import './ItemDetailsModal.scss';

const PulseModal = (props) => (
  <Modal show={props.showPulseModal} width="75%">
    <div className="flex-container-row item-details-container show">
      <Pulse text="Saving Items" />
    </div>
  </Modal>
);

export default PulseModal;
